import { createTheme } from '@mui/material/styles';
import NextLink from 'next/link';
import palette from './pallete';
import shape from '../common/shape';
import typography from './typography';
import breakpoints from '../common/breakpoints';
import getTabs from '../common/tabs';
import getMuiButton from '../common/getMuiButton';
import { MuiOutlinedInput } from '../common/muiOutlinedInput';
import { MuiTable } from '../common/muiTable';
import { MuiFormHelperText } from '../common/muiFormHelperText';
import { MuiChip } from '../common/muiChip';
import {
  MuiCheckbox,
  MuiRadio,
  MuiFormGroup,
  MuiFormControlLabel,
} from '../common/muiCheckbox';
import { MuiSelect } from '../common/muiSelect';
import { MuiCssBaseline } from '../common/muiCssBaseline';
import { MuiMenu } from '../common/muiMenu';
import { MuiInputLabel } from '../common/muiInputLabel';
import { MuiAutocomplete } from '../common/muiAutocomplete';
import { MuiTypography } from '../common/muiTypography';
import { MuiPaper } from '../common/muiPaper';
import { MuiPickersTextField } from '../common/muiPickersTextField';
import customShadows from '../common/shadows';

export const themeKc = createTheme({
  palette,
  shape,
  typography,
  breakpoints,
  customShadows,
  components: {
    // Components from the @web-shared/core package: brand defaults are configured here rather
    // than passed at every call site, so the package itself stays brand-free.
    MpBreadcrumb: { defaultProps: { linkComponent: NextLink } },
    MpUploadedFile: { defaultProps: { variant: 'filled' } },
    ...getTabs('kc'),
    ...MuiTable,
    MuiChip,
    MuiCheckbox,
    MuiRadio,
    MuiFormGroup,
    MuiFormControlLabel,
    MuiMenu,
    MuiSelect,
    MuiAutocomplete,
    MuiOutlinedInput,
    MuiPickersTextField,
    MuiFormHelperText,
    MuiCssBaseline,
    MuiInputLabel,
    MuiTypography,
    MuiPaper,
    MuiButton: getMuiButton('kc'),
  },
});
